import api from './api';

export interface SellerBalanceSettings {
  commissionRate: number;
  minWithdrawalAmount: number;
  maxWithdrawalAmount: number;
  withdrawalExpirationDays: number;
  autoRejectExpiredWithdrawals: boolean;
  requireBankAccountVerification: boolean;
}

export interface SellerBalanceStats {
  totalSellers: number;
  totalBalance: number;
  pendingWithdrawals: number;
  completedWithdrawals: number;
  averageBalance: number;
}

export interface SimulationResult {
  estimatedCommission: number;
  estimatedNetAmount: number;
  isValid: boolean;
  message?: string;
}

class SellerBalanceSettingsService {
  private baseURL = '/admin/seller-balance-settings';

  /**
   * Get seller balance settings
   */
  async getSettings(): Promise<SellerBalanceSettings> {
    const response = await api.get(this.baseURL);
    return (response as any)?.data || response;
  }

  /**
   * Update seller balance settings
   */
  async updateSettings(settings: Partial<SellerBalanceSettings>): Promise<SellerBalanceSettings> {
    const response = await api.put(this.baseURL, settings);
    return (response as any)?.data || response;
  }

  /**
   * Recalculate all seller balances
   */
  async recalculateAllBalances(): Promise<{ affected: number; message: string }> {
    const response = await api.post(`${this.baseURL}/recalculate`);
    return (response as any)?.data || response;
  }

  /**
   * Check and reject expired withdrawals
   */
  async checkExpiredWithdrawals(): Promise<{ rejectedCount: number; message: string }> {
    const response = await api.post(`${this.baseURL}/check-expired`);
    return (response as any)?.data || response;
  }

  /**
   * Get seller balance statistics
   */
  async getStats(): Promise<SellerBalanceStats> {
    const response = await api.get(`${this.baseURL}/stats`);
    return (response as any)?.data || response;
  }

  /**
   * Test settings with simulation
   */
  async testSettings(testData: { amount: number; sellerId?: string }): Promise<SimulationResult> {
    const response = await api.post(`${this.baseURL}/test`, testData);
    return (response as any)?.data || response;
  }
}

export const sellerBalanceSettingsService = new SellerBalanceSettingsService();
export default sellerBalanceSettingsService;

